import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class AppontmentlocalService {
  appArray = [];
  constructor() {}

  saveAppArray(appArray) {
    this.appArray = appArray;
  }
  getAppArray() {
    return this.appArray;
  }
}
